module.exports = __webpack_public_path__ + "69e4c5ca746066cfe8470d781362c5c4.jpg";